export default __webpack_public_path__ + "static/media/not-found.f1d9204d.png";